import React, { useEffect, useRef } from "react";
import { StepProps } from "./types";
import { greenCheck, pendingIcon } from "../../../../assets/images";
import { useTutorial } from "./TutorialContext";

const Step: React.FC<StepProps> = ({
  title,
  subheading,
  status,
  url,
  id,
  index,
  isLast,
  ...props
}) => {
  const { themeManager, handleNextStep, handleStepLoad } = useTutorial();
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      handleStepLoad(index, contentRef.current.offsetHeight);
    }
  }, [index, handleStepLoad]);
  
  return (
    <div
      className="q_tutorial_box"
      id={`q_tutorial_box_${index}`}
      onClick={() => url && handleNextStep(id, url)}
      {...props}
    >
      <div className="q_tutorial_progress">
        <div
          className="q_tutorial_progress_img_cont"
          style={themeManager.getProgressStyles(Boolean(status)).imageCont}
        >
          <img
            className="q_tutorial_progress_icon"
            style={{ width: "16px", height: "16px" }}
            src={status ? greenCheck : pendingIcon}
            alt=""
          />
        </div>
        {!isLast && (
          <div
            id={`q_tutorial_progress_connector_${index}`}
            className="q_tutorial_progress_connector"
            style={themeManager.getProgressStyles(Boolean(status)).connector}
          />
        )}
      </div>
      <div
        id={`q_tutorial_box_content_${index}`}
        className="q_tutorial_box_content"
        ref={contentRef}
      >
        <div className="q_tut_step" style={themeManager.getStepStyles().step}>
          STEP {index + 1}
        </div>
        <div
          className="q_tut_box_head"
          style={themeManager.getStepStyles().title}
        >
          {title}
        </div>
        <div
          className="q_tut_box_desc"
          style={themeManager.getStepStyles().description}
        >
          {subheading}
        </div>
      </div>
    </div>
  );
};

export default Step;
